import React, { useCallback, useEffect, useState } from 'react';
import { getQuizzes, getUserById } from './utils/quiz';

import { Link } from 'react-router-dom';
import QuizCard from './quiz/QuizCard';
import { useTranslation } from 'react-i18next';
import { useWalletSelector } from './utils/WalletSelectorContext';

const Profile = ({ account, balance, logout }) => {
  const [quizzes, setQuizzes] = useState([]);
  const [myQuizzes, setMyQuizzes] = useState([]);
  const [chosenTab, setChosenTab] = useState(2);
  const [user, setUser] = useState(null);

  const { t, i18n } = useTranslation();

  const getQuiz = useCallback(async () => {
    try {
      const usr = await getUserById(account.accountId);
      const qzs = await getQuizzes();
      console.log(qzs);
      // loop over the quizzes and check if the current user is in the array specificUsers
      // if yes, then add the quiz to the array
      setMyQuizzes(qzs);
      setUser(usr);
      setQuizzes(
        qzs
          .filter(
            (q) =>
              new Date(q.availableTill / 1000000).getTime() >=
              new Date().getTime()
          )
          .filter(
            (q) =>
              q.specificUsers.length === 0 ||
              q.specificUsers.includes(account.accountId)
          )
          .filter((q) => {
            return (
              !usr.quizSubmissions.hasOwnProperty(q.quizId) ||
              usr.quizSubmissions[q.quizId].submittedTimes <
                q.allowMultipleTrials
            );
          })
          .reverse()
      );
    } catch (error) {
      const qzs = await getQuizzes();
      setQuizzes(
        qzs
          .filter(
            (q) =>
              q.specificUsers.length === 0 ||
              q.specificUsers.includes(account.accountId)
          )
          .filter(
            (q) =>
              new Date(q.availableTill / 1000000).getTime() >=
              new Date().getTime()
          )
          .reverse()
      );
      // console.log({ error });
    }
  });

  useEffect(() => {
    getQuiz();
  }, []);

  const { modal } = useWalletSelector();

  const handleLogin = () => modal.show();

  return account.accountId ? (
    <div className='py-8'>
      <header
        className={
          i18n.language === 'ar'
            ? 'flex flex-col justify-between items-center md:flex-row-reverse'
            : 'flex flex-col justify-between items-center md:flex-row'
        }>
        <div className='w-[150px] h-[150px] bg-primary-600 rounded-full flex items-center justify-center'>
          {/* <img
            src='https://i.pravatar.cc/150?u=omar'
            alt='avatar placeholder'
          /> */}
          <span className='text-6xl font-bold text-white dark:text-dark-700'>
            {account.accountId[0].toUpperCase()}
          </span>
        </div>
        <div
          className={
            i18n.language === 'ar'
              ? 'flex flex-col gap-2 ml-auto md:mr-8 my-4 md:my-0 items-start md:w-auto w-full md:mx-auto md:text-right'
              : 'flex flex-col gap-2 mr-auto md:ml-8 my-4 md:my-0 items-start md:w-auto w-full md:mx-auto md:text-left'
          }>
          <h2 className='text-3xl font-bold uppercase w-full'>
            {account.accountId}
          </h2>
          <h4 className='text-lg font-semibold w-full'>{balance} NEAR</h4>
        </div>
        <div
          className={
            i18n.language === 'ar'
              ? 'flex gap-3 sm:flex-row-reverse flex-col w-full md:w-auto'
              : 'flex gap-3 sm:flex-row flex-col w-full md:w-auto'
          }>
          {/* <CreateQuiz save={add_quiz} /> */}
          <Link
            to='/create'
            dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}
            className='inline-flex w-full items-center justify-center sm:mt-0
            gap-0 py-2 px-4 text-center text-white bg-lime-700 rounded-lg
            hover:bg-lime-800 focus:ring-4 focus:outline-none
            focus:ring-lime-300 dark:bg-lime-600 dark:hover:bg-lime-700
            dark:focus:ring-lime-800'>
            <p className='inline md:hidden mr-2'>{t('profile-create-title')}</p>
            <svg
              className='w-10 h-10 min-w-[20px] max-w-[25px]'
              fill='none'
              stroke='currentColor'
              viewBox='0 0 24 24'
              xmlns='http://www.w3.org/2000/svg'>
              <path
                strokeLinecap='round'
                strokeLinejoin='round'
                strokeWidth='2'
                d='M12 6v6m0 0v6m0-6h6m-6 0H6'></path>
            </svg>
          </Link>
          <button
            title={t('logout')}
            onClick={logout}
            className='inline-flex items-center justify-center min-w-fit w-full gap-2 py-4 px-6 text-center text-white bg-red-700 rounded-lg hover:bg-red-800 focus:ring-4 focus:outline-none focus:ring-red-300 dark:bg-red-600 dark:hover:bg-red-700 dark:focus:ring-red-800'>
            {t('logout')}
            <svg
              className='w-6 h-6 min-w-[20px]'
              fill='none'
              stroke='white'
              viewBox='0 0 24 24'
              xmlns='http://www.w3.org/2000/svg'>
              <path
                strokeLinecap='round'
                strokeLinejoin='round'
                strokeWidth='2'
                d='M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1'></path>
            </svg>
          </button>
        </div>
      </header>

      <main>
        <ul className='flex flex-col md:flex-row gap-3 mx-auto mt-6'>
          <li className='w-full'>
            <input
              type='radio'
              id='hosting-small'
              name='hosting'
              value='hosting-small'
              className='hidden peer'
              onClick={() => setChosenTab(1)}
            />
            <label
              htmlFor='hosting-small'
              dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}
              className='inline-block font-semibold text-2xl p-5 w-full text-slate-500 rounded-lg border-[3px] border-gray-200 cursor-pointer dark:hover:text-gray-300 dark:border-gray-700 dark:peer-checked:text-slate-50 peer-checked:border-primary-400 dark:peer-checked:border-primary-600 peer-checked:text-slate-900 hover:bg-gray-100 hover:bg-opacity-50 dark:text-slate-600 dark:hover:bg-white dark:hover:bg-opacity-5'>
              {t('profile-radio-1')} (
              {
                myQuizzes.filter((q) => q.createdBy === account.accountId)
                  .length
              }
              )
            </label>
          </li>
          <li className='w-full'>
            <input
              type='radio'
              id='hosting-big'
              name='hosting'
              value='hosting-big'
              className='hidden peer'
              onClick={() => setChosenTab(2)}
              defaultChecked
            />
            <label
              htmlFor='hosting-big'
              dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}
              className='inline-block font-semibold text-2xl p-5 w-full
              text-slate-500 rounded-lg border-[3px] border-gray-200
              cursor-pointer dark:hover:text-gray-300 dark:border-gray-700
              dark:peer-checked:text-slate-50 peer-checked:border-primary-400 dark:peer-checked:border-primary-600
              peer-checked:text-slate-900 hover:bg-gray-100 hover:bg-opacity-50
              dark:text-slate-600 dark:hover:bg-white dark:hover:bg-opacity-5'>
              {t('profile-radio-2')} (
              {quizzes.filter((q) => q.createdBy !== account.accountId).length})
            </label>
          </li>
        </ul>

        <hr className='sm:hidden mt-4 dark:opacity-20' />

        <div className='mt-4 flex flex-col gap-3 grid-cols-[repeat(auto-fill,_minmax(240px,_1fr))]'>
          {chosenTab === 1 &&
            myQuizzes
              .filter((q) => q.createdBy === account.accountId)
              .map((q) => (
                <QuizCard
                  acc={account}
                  usr={user}
                  quiz={q}
                  key={q.quizId}
                  viewOnly={true}
                />
              ))}
          {chosenTab === 2 &&
            quizzes
              .filter((q) => q.createdBy !== account.accountId)
              .map((q) => (
                <QuizCard usr={user} acc={account} quiz={q} key={q.quizId} />
              ))}
        </div>
      </main>
    </div>
  ) : (
    <div className='flex flex-col gap-4 justify-center items-center h-[75vh]'>
      <h1 className='text-4xl font-bold text-gray-700 dark:text-gray-300'>
        You are not logged in
      </h1>
      <button
        title='Login'
        onClick={handleLogin}
        className='inline-flex items-center justify-center mt-3 sm:mt-0 gap-0 py-4 px-6 text-center text-white bg-primary-600 rounded-lg hover:bg-primary-700 font-semibold focus:ring-4 focus:outline-none focus:ring-primary-300 dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800'>
        Login
      </button>
    </div>
  );
};

export default Profile;
